import { styled } from "@mui/material/styles";
import type { Variants } from "framer-motion";
import { m } from "framer-motion";
import type { ComponentProps, ReactNode } from "react";
import { motionConfig } from "@/themes/motion.config";

const { spring, duration, easing } = motionConfig;

// Icon container - slides in/out horizontally
const IconWrapper = styled(m.div)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const iconVariants: Variants = {
  initial: { x: 20, scale: 0.5, opacity: 0 },
  animate: { x: 0, scale: 1, opacity: 1, transition: spring.stiff },
  exit: {
    x: -20,
    scale: 0.5,
    opacity: 0,
    transition: { duration: duration.fast, ease: easing.in },
  },
};

export function AnimatedIconContainer({
  children,
  ...rest
}: ComponentProps<typeof IconWrapper> & { children: ReactNode }) {
  return (
    <IconWrapper variants={iconVariants} initial="initial" animate="animate" exit="exit" {...rest}>
      {children}
    </IconWrapper>
  );
}

// Checkmark container - scales in/out
const CheckmarkWrapper = styled(m.div)({
  display: "flex",
});

const checkmarkVariants: Variants = {
  initial: { scale: 0, opacity: 0 },
  animate: { scale: 1, opacity: 1, transition: { ...spring.stiff, delay: duration.fast } },
  exit: { scale: 0, opacity: 0, transition: { duration: duration.fast } },
};

export function AnimatedCheckmarkContainer({
  children,
  ...rest
}: ComponentProps<typeof CheckmarkWrapper> & { children: ReactNode }) {
  return (
    <CheckmarkWrapper
      variants={checkmarkVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      {...rest}
    >
      {children}
    </CheckmarkWrapper>
  );
}
